﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalBrokerage`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetBrokerageProducts' },
  { name: 'GetBrokerageCategories' },
  { name: 'GetBrokerageHeaderItems' },
]);

const GetBrokerageProducts = () => api.endpoints.GetBrokerageProducts.post();
const GetBrokerageCategories = () => api.endpoints.GetBrokerageCategories.post();
const GetBrokerageHeaderItems = () => api.endpoints.GetBrokerageHeaderItems.post();

export { GetBrokerageProducts, GetBrokerageCategories, GetBrokerageHeaderItems };
